import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onEditPaymentClick", "onBillingHistoryClick", "user", "darkMode"];
import React from 'react';
import { Segment, Header, Image } from 'semantic-ui-react';
import { ButtonLink } from '@emyw/auth-lib';
import '../custom-theme.css';
var REACT_APP_ACCOUNT_API_IMAGE_PATH = process.env.REACT_APP_ACCOUNT_API_IMAGE_PATH;
var PaymentDetail = function PaymentDetail(_ref) {
  var onEditPaymentClick = _ref.onEditPaymentClick,
    onBillingHistoryClick = _ref.onBillingHistoryClick,
    user = _ref.user,
    darkMode = _ref.darkMode,
    props = _objectWithoutProperties(_ref, _excluded);
  if (user.subscriptionLevelCode === 'FREE' && window.location.pathname.indexOf('signup') > -1) return null;
  var cardImgSrc = "".concat(REACT_APP_ACCOUNT_API_IMAGE_PATH, "/").concat((user.paymentMethod === 'IAP' ? (user.iapPlatform || '').toLowerCase() : (user.paymentMethod || '').toLowerCase().replace(' ', '')) || '', ".png");
  if (darkMode) cardImgSrc = cardImgSrc.replace(/mastercard/, 'mastercard-dark-mode').replace(/paypal/, 'paypal-dark-mode');
  var iapLink = '';
  if (user.iapPlatform === 'AMAZON') iapLink = 'https://www.amazon.com/appstoresubscriptions';else if (user.iapPlatform === 'APPLE') iapLink = 'https://support.apple.com/billing';else if (user.iapPlatform === 'ROKU') iapLink = 'https://my.roku.com/account/subscriptions';
  return /*#__PURE__*/React.createElement(Segment, Object.assign({
    className: "subscriptionPlanSummary",
    clearing: true,
    size: "mini"
  }, props), /*#__PURE__*/React.createElement(Header, {
    className: "subscribeDetailSummary lighter",
    floated: "left",
    style: {
      margin: 'auto'
    }
  }, /*#__PURE__*/React.createElement("div", null, "".concat(user.firstName, " ").concat(user.lastName)), /*#__PURE__*/React.createElement(Image, {
    size: "large",
    inline: true,
    src: cardImgSrc
  })), /*#__PURE__*/React.createElement(Header, {
    className: "changeSubscribeItem light",
    floated: "right"
  }, user.paymentMethod !== 'IAP' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ButtonLink, {
    onClick: onEditPaymentClick
  }, "Edit Payment Info"), /*#__PURE__*/React.createElement("br", null), window.location.pathname.indexOf('signup') === -1 && /*#__PURE__*/React.createElement(ButtonLink, {
    onClick: onBillingHistoryClick,
    style: {
      paddingTop: '0.5em!important',
      float: 'right'
    }
  }, "Billing History")), user.paymentMethod === 'IAP' && /*#__PURE__*/React.createElement("a", {
    href: "".concat(iapLink),
    target: "_blank"
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      textAlign: 'right'
    }
  }, "Manage Subscription", /*#__PURE__*/React.createElement("br", null), "at ", (user.iapPlatform || '').toLowerCase(), ".com"))));
};
PaymentDetail.defaultProps = {
  user: undefined,
  darkMode: false
};
export default PaymentDetail;